"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NuiClient;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _nuiAuth = require("@concur/nui-auth");
var _nuiIntlRuntime = _interopRequireWildcard(require("@concur/nui-intl-runtime"));
var _safeCookies = _interopRequireDefault(require("@concur/safe-cookies"));
var _reactRouter = require("react-router");
var _userPreferences = require("../modules/userPreferences");
var _ErrorHandler = _interopRequireDefault(require("./ErrorHandler"));
var _getErrorStore = require("../util/getErrorStore");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function NuiClient(_ref) {
  var store = _ref.store,
    mapStateToError = _ref.mapStateToError,
    router = _ref.router,
    _ref$initialState = _ref.initialState,
    initialState = _ref$initialState === void 0 ? {} : _ref$initialState;
  (0, _safeCookies.default)();
  var resilientStore = store || (0, _getErrorStore.getErrorStore)(initialState);
  var state = resilientStore.getState();
  var _state$userPrefs = state.userPrefs,
    userPrefs = _state$userPrefs === void 0 ? {} : _state$userPrefs;

  // Fetch user prefs if they do not exist
  (0, _react.useEffect)(function () {
    if (Object.keys(userPrefs).length === 0) {
      var userPrefsAction = (0, _userPreferences.fetchUserPrefs)();
      resilientStore.dispatch(userPrefsAction);
    }
  }, []);
  var localeData = (0, _nuiIntlRuntime.getLocaleData)(state);
  return /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: resilientStore,
    key: "provider"
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.default, {
    localeData: localeData
  }, /*#__PURE__*/_react.default.createElement(_ErrorHandler.default, {
    mapStateToError: mapStateToError
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "react-component-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_nuiAuth.JwtRefresher, null), /*#__PURE__*/_react.default.createElement(_reactRouter.RouterProvider, {
    router: router
  })))));
}
NuiClient.propTypes = {
  children: _propTypes.default.any,
  router: _propTypes.default.object,
  store: _propTypes.default.object,
  initialState: _propTypes.default.object,
  mapStateToError: _propTypes.default.func
};